/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { popupSocialShareData } from "../utils";
import { updateBodyScroll } from "../../../../utils";

import "./popup.m.css";
import { SvgHandler } from "../../../svg-handler/svg-handler";
import PropTypes from "prop-types";
import close from "../../../../../assets/icons/social/close.svg";

function popupSocialShareItem(url, icon, bgColor, text, alt, index) {
  return (
    <li data-testid={text} key={`popup-item-${index}`}>
      <a href={url} target="_blank" rel="noopener noreferrer" styleName="social-wrapper">
        <span styleName="social-icon" style={{ backgroundColor: bgColor }}>
          {icon}
        </span>
        <span styleName="social-text">{text}</span>
      </a>
    </li>
  );
}

export class Popup extends React.Component {
  componentDidMount() {
    updateBodyScroll(true);
  }

  componentWillUnmount() {
    updateBodyScroll();
  }

  render() {
    const { fbUrl, twitterUrl, linkedinUrl, whatsappUrl, closePopup, grey } = this.props;
    const popupItemsList = popupSocialShareData({ fbUrl, twitterUrl, linkedinUrl, whatsappUrl });
    const greyColor = grey ? "grey-color-icons" : "";
    return (
      <div styleName={`share-popup-wrapper ${greyColor}`}>
        <div styleName="share-popup">
          <div styleName="top-bar">
            <span styleName="share-text">Share it</span>
            <span styleName="close" onClick={closePopup}>
              <SvgHandler width="24" height="24" clazzName="cross-icon" xlinkHref={close} />
            </span>
          </div>
          <ul>
            {popupItemsList.map(({ url, icon, bgColor, text, alt }, index) =>
              popupSocialShareItem(url, icon, bgColor, text, alt, index)
            )}
          </ul>
        </div>
      </div>
    );
  }
}

Popup.propTypes = {
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  gplusUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  grey: PropTypes.string,
  primaryColor: PropTypes.string,
  closePopup: PropTypes.bool
};
